import { render, staticRenderFns } from "./SubscriptionHeader.vue?vue&type=template&id=47e60a1f&scoped=true&"
import script from "./SubscriptionHeader.vue?vue&type=script&lang=js&"
export * from "./SubscriptionHeader.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionHeader.vue?vue&type=style&index=0&id=47e60a1f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e60a1f",
  null
  
)

export default component.exports